import ReactPixelModule from 'react-facebook-pixel';

// The package is webpack-built CommonJS that sets __esModule. With "type": "module", Node and Bun
// make the default import the whole module.exports, so the pixel API is on its .default.
const ReactPixel = (ReactPixelModule as unknown as { default?: typeof ReactPixelModule }).default ?? ReactPixelModule;

export default ReactPixel;
